import React from "react";

import { BlueprintIcon, BlueprintIconProps } from "../blueprint-icon";

export const CloseCircle: React.FC<BlueprintIconProps> = (props) => (
  <BlueprintIcon viewBox="0 0 16 16" {...props}>
    <circle cx="8" cy="8" r="8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.1716 3.75736L3.75738 5.17157L6.58581 8L3.75738 10.8284L5.1716 12.2426L8.00002 9.41421L10.8284 12.2426L12.2427 10.8284L9.41424 8L12.2427 5.17157L10.8284 3.75736L8.00002 6.58579L5.1716 3.75736Z"
      fill="white"
    />
  </BlueprintIcon>
);
